
    import Vue from 'vue';
    import { RouterLink } from 'vue-router'
    import FilePathService from '@/apps/shared/services/filePath-service';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import getQuotationPersonsRelationService from '@/apps/shared/services/getQuotationPersonsRelation-service';
    export default Vue.extend({
        components: {
            RouterLink,
        },
        busEvents: {
        },
        name: 'healthMaxFamilyUpload-view',
        data() {
            return {
                capital: null,
                coversDetail: [],
                planName: null,
                maxSelections: 2,
                effectDate: null,
                primerCuota: 0,
                DataPlan: {
                    planDescription: ''
                },
                expirationDate: null,
                activeStep: 0,
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                isNotSelectedDocumentType: true,
                payButtonDisable: true,
                addChildDisable: false,
                addSpouseDisable: false,
                messageErrorAge: null,
                validatePhone: false,
                messageError: null,
                validDigits: null,
                currentStep: 1,
                totalStep: 2,
                currentGroup: null,
                isLastStep: true,
                familyMembers: [],
                kinshipRelations: [{ id: 1, name: "Hijo/a" }, { id: 3, name: "Cónyuge" }],
                addChild: false,
                personToAdd: {
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: null,
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    address: null,
                    document: null,
                    maximDigitSuperatedDni: false,
                    activeFormPersonNotExist: false,
                    isEqualToPolicyOwner: false,
                    isEqualToPersonToCover: false,
                    alreadyExists: false,
                },
                searchButtonDisable: true,
                personToAddRelationText: "",
                personToAddDocTypeSelected: null,
                personToAddNumDoc: null,
                isPersonToAddNotSelectedDocumentType: true,
                quotationPersonsRelationList: [],
                addSpouseDisableTooltipText: "",
                addChildDisableTooltipText: "",
                familyToCover: 0,
                isAssuredTitular: false,
                personToCover: null,
                policyOwner: null,
                numDocChange: null,
                numDocExisting: null,
                personToDelete: {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    kinship: { name: "" },
                    birthday: null,
                },
                personToEdit: {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    kinship: { name: "" },
                    birthday: null,
                },
                localItems: [{ text: 'Inicio', path: '/salud-segura-max' },
                { text: 'Agregar Familiar Asegurado', path: '/salud-segura-max/datosFamiliar' }],
                isPerson: false,
                isJuridico: false,
                multiplePeopleWithSameIdentifier: [],
                isSearchPersonToCover: false,
                personWithSameIdentifierSelected: null,
                personToEditId: null,
                isPeopleWithSameIdentifierModalOpen: false,
                premiumWithoutDiscount: null,
                thereIsDiscount: false,
                additionalCovers: [],
            };
        },
        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true
                let message = ""
                if (this.personToAddDocTypeSelected.id == 'D' && val.length != 7 && val.length != 8) {
                    this.searchButtonDisable = true;
                    if (val.length > 0) {
                        valid = false
                        message = "La cantidad de dígitos es incorrecta."
                    }
                    else {
                        valid = false
                        message = "Este campo es obligatorio."
                    }
                } else if (this.personToAddDocTypeSelected.id == 'D' && (val.length == 7 || val.length == 8)) {
                    if (this.numDocExisting != val) {
                        this.numDocChange = true;
                        this.numDocExisting = val;
                    }

                    this.searchButtonDisable = false;
                    message = "";
                    valid = true;
                }
                else {
                    this.searchButtonDisable = false;
                }
                return {
                    valid,
                    message
                }
            };
        },
        methods: {
            disableAcceptNewPersonButton() {
                return this.personToAddNumDoc == '' || this.personToAddNumDoc == null || this.personToAddDocTypeSelected == null || this.personToAdd.birthday == null ||
                    this.personToAdd.firstName == null || this.personToAdd.firstName == '' || this.personToAdd.lastName == null || this.personToAdd.lastName == '' ||
                    !this.personToAdd.isBirthdayCorrect;
            },
            openCancelModal: function () {
                this.$refs.cancelModal.open();
            },
            closeCancelModal: function () {
                this.$refs.cancelModal.close();
            },
            closeDeleteFamiliarModal() {
                this.$refs.deleteFamiliarModal.close();
                this.resetPersonToDelete();
            },
            openEditFamiliarModal(item) {
                this.personToEdit = {
                    id: item.id,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    docNum: item.docNum,
                    docType: item.docType,
                    kinship: item.kinship,
                    birthday: item.birthday,
                };
                this.$refs.personToAddModal.open();
            },
            resetPersonToDelete() {
                this.personToDelete = {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    kinship: { name: "" },
                    birthday: null,
                };
            },
            resetPersonToEdit() {
                this.personToEdit = {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    kinship: { name: "" },
                    birthday: null,
                };
            },
            openDeleteFamiliarModal(item) {
                this.personToDelete = {
                    id: item.id,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    docNum: item.docNum,
                    docType: item.docType,
                    kinship: item.kinship,
                    birthday: item.birthday,
                };
                this.$refs.deleteFamiliarModal.open();
            },
            openSelectMultiplePeopleModal: function (peopleList) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                // Inicializar el array multiplePeopleWithSameIdentifier
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => {
                    let newPerson = {
                        id: idCounter++,
                        birthday: person.birthday,
                        firstName: person.firstName,
                        lastName: person.lastName,
                        email: person.email,
                        selectedIvaCondition: person.ivaConditionFiscalId,
                        areaCode: person.phoneAreaCode,
                        telephone: person.phoneNumber,
                        hasLocality: person.hasLocality,
                        address: null,
                        document: null
                    };
                    if (person.address != null && person.address != undefined) {
                        newPerson.address = {
                            cityId: person.address.cityId,
                            streetNumber: person.address.streetNumber,
                            streetName: person.address.streetName,
                            zipCode: person.address.zipCode,
                            floor: person.address.floor,
                            department: person.address.department
                        };
                    }
                    if (person.document != null && person.document != undefined) {
                        newPerson.document = person.document;
                    };
                    return newPerson;
                });
                this.$refs.selectMultiplePeopleModal.open();
            },
            resetPersonToAddModal() {
                this.personToAddDocTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                this.personToAddNumDoc = "";
                this.resetPersonToEdit();
                this.resetPersonToAdd();
            },
            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
            },
            closeSelectMultiplePeopleModal: function (flag = true) {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                if (flag) {
                    this.resetPersonToAddModal();
                }
                this.$refs.selectMultiplePeopleModal.close();
            },
            onSelectedClient(id) {
                this.personWithSameIdentifierSelected = id;
                let selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => this.personWithSameIdentifierSelected == item.id);

                this.personToAdd.isEqualToPolicyOwner = (this.personToAddNumDoc === this.policyOwner.numDoc
                    && this.personToAddDocTypeSelected.id === this.policyOwner.docTypeSelected.id
                    || (this.personToAddNumDoc === this.policyOwner.numDoc
                        && selectedPerson.firstName === this.policyOwner.firstName && selectedPerson.lastName === this.policyOwner.lastName));

                if (!this.isAssuredTitular) {
                    this.personToAdd.isEqualToPersonToCover = (this.personToAddNumDoc === this.personToCover.numDoc
                        && this.personToAddDocTypeSelected.id === this.personToCover.docTypeSelected.id
                        || (this.personToAddNumDoc === this.personToCover.numDoc
                            && selectedPerson.firstName === this.personToCover.firstName && selectedPerson.lastName === this.personToCover.lastName));
                }

                this.personToAdd.alreadyExists = this.familyMembers.some(member =>
                    (member.docType.id === this.personToAddDocTypeSelected.id &&
                        member.docNum === this.personToAddNumDoc)
                    || (member.docNum === this.personToAddNumDoc
                        && selectedPerson.firstName === member.firstName && selectedPerson.lastName === member.lastName)
                );

                this.setPersonToAdd(selectedPerson);
                this.ageCalculate();

                if (this.personToAddNumDoc != "" && this.personToAddNumDoc != null && this.personToAdd.isBirthdayCorrect &&
                    !this.personToAdd.isEqualToPolicyOwner && !this.personToAdd.isEqualToPersonToCover && !this.personToAdd.alreadyExists) {
                    this.finallySetPersonToAddOrEdit();
                    this.closeSelectMultiplePeopleModal();
                }
                else {
                    this.closeSelectMultiplePeopleModal(false);
                }
            },
            deleteFamiliar(id) {
                // Encuentra el índice del elemento con el id especificado
                const indexAEliminar = this.familyMembers.findIndex(member => member.id === id);

                // Si se encuentra el elemento con ese id, se elimina
                if (indexAEliminar !== -1) {
                    this.familyMembers.splice(indexAEliminar, 1);
                };
                this.closeDeleteFamiliarModal();
            },
            closePersonToAddModal() {
                this.$refs.personToAddModal.close();
                if (!this.isPeopleWithSameIdentifierModalOpen) {
                    this.resetPersonToAddModal();
                };
            },
            resetPersonToAdd() {
                this.personToAdd = {
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: null,
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    address: null,
                    maximDigitSuperatedDni: false,
                    activeFormPersonNotExist: false,
                    isEqualToPolicyOwner: false,
                    isEqualToPersonToCover: false,
                    alreadyExists: false,
                };
            },
            openPersonToAddModal() {
                this.personToAddDocTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
                this.$refs.personToAddModal.open();
            },
            addFamily(isChild) {
                this.addChild = isChild;
                this.personToAddRelationText = isChild ? this.kinshipRelations.find(relation => relation.id === 1).name : this.kinshipRelations.find(relation => relation.id === 3).name;
                this.openPersonToAddModal();
            },
            isPersonToAddSelectedDocumentType: function () {
                this.isNotSelectedDocumentType = false;
                this.personToAddDocTypeSelected != null ? this.personToAddDocTypeSelected.name.trim() != "CUIT" ? (this.isPerson = true, this.isJuridico = false) : (this.isJuridico = true, this.isPerson = false) : null
                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
            },
            anterior() {
                sessionStorage.setItem("pressBack", "true");
                let isAssuredTitular = sessionStorage.getItem("isAssuredTitular") === 'true';
                if (isAssuredTitular) {
                    let pricingId = parseInt(sessionStorage.getItem("selectedPricingId"));
                    window.location.href = '../salud-segura-max/contratante' + "?cotizacion=" + pricingId;
                } else {
                    let pricingId = parseInt(sessionStorage.getItem("selectedPricingId"));
                    window.location.href = '../salud-segura-max/datosAsegurado' + "?cotizacion=" + pricingId;
                }
            },
            pagar() {
                sessionStorage.setItem("pressBack", "false");
                sessionStorage.setItem("familyMembers", JSON.stringify(this.familyMembers));
                CRMCotizadorWebService.CreateOrEditLead(this.email, location.href, null, null, 321, false, "4");
                let pricingId = parseInt(sessionStorage.getItem("selectedPricingId"));
                try {
                    window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-datos-familiar' });
                    window.location.href = '../salud-segura-max/pago' + "?cotizacion=" + pricingId;
                } catch {
                    window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'errorServidor', 'paso': 'cotizador-salud-datos-familiar' });
                }
            },
            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Salud Segura Max';
                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear().toString();
                return `${day}/${month}/${year}`;
            },
            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "salud-segura-max";
                    });
            },
            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element =>
                            ({ ...element, id: element["id"], text: element["name"] }))
                        this.personToAddDocTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                })
            },
            getIvaConditions() {
                ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length != 0) {
                        this.ivaConditionList = response.map(element => ({ ...element, id: element["id"].toString(), text: element["name"] }))
                    }
                })
            },
            getQuotationPersonsRelation() {
                let onDate = new Date().toISOString();
                getQuotationPersonsRelationService.getQuotationPersonsRelation(321, onDate)
                    .then(quotationPersonsRelation => {
                        this.quotationPersonsRelationList = quotationPersonsRelation.quotationPersonsRelationList;
                        sessionStorage.setItem("responseQuotationPersonsRelation", JSON.stringify(quotationPersonsRelation.quotationPersonsRelationList));
                    });
            },
            addNewPerson(personToEditId = 0) {
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.docType = this.personToAddDocTypeSelected;
                this.addOrEditPerson(personToEditId);
            },
            setPersonToAdd(personToAdd) {
                this.personToAdd.activeFormPersonNotExist = false;
                this.personToAdd.isPersonExist = true;
                this.personToAdd.activeForm = true;
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.docType = this.documentTypeList.find(p => p.id.trim() == personToAdd.document.identificationTypeCode);
                this.personToAdd.birthday = personToAdd.birthday;
                this.personToAdd.firstName = personToAdd.firstName;
                this.personToAdd.lastName = personToAdd.lastName;
                this.personToAdd.email = personToAdd?.email ?? "";
                this.personToAdd.selectedIvaCondition = personToAdd.ivaConditionFiscalId != null && personToAdd.ivaConditionFiscalId != 0 && personToAdd.ivaConditionFiscalId != undefined ? (this.ivaConditionList.find(o => o.id == personToAdd.ivaConditionFiscalId || o.name == personToAdd.ivaConditionFiscalId)) : (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"))
                this.personToAdd.areaCode = personToAdd?.phoneAreaCode?.replace(/^0+/, '') ?? "";
                this.personToAdd.telephone = personToAdd?.phoneNumber?.replace(/^15+/, '') ?? null;
                this.personToAdd.hasLocality = personToAdd.hasLocality;
                if (personToAdd.address != null && personToAdd.address != undefined) {
                    this.personToAdd.address = {
                        cityId: personToAdd.address.cityId,
                        streetNumber: personToAdd.address.streetNumber,
                        streetName: personToAdd.address.streetName,
                        zipCode: personToAdd.address.zipCode,
                        floor: personToAdd.address.floor,
                        department: personToAdd.address.department
                    };
                }
                if (personToAdd.document != null && personToAdd.document != undefined) {
                    this.personToAdd.document = personToAdd.document;
                }
            },
            searchPersonToAdd(personToEditId = 0) {
                NF.UI.Page.blockCustom({ message: 'Cargando datos...' });
                this.personToEditId = personToEditId;
                this.personToAdd = {
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: null,
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    maximDigitSuperatedDni: false,
                    address: null,
                    activeFormPersonNotExist: false,
                    isEqualToPolicyOwner: false,
                    isEqualToPersonToCover: false,
                    alreadyExists: false,
                };
                this.personToAdd.isEqualToPolicyOwner = (this.personToAddNumDoc === this.policyOwner.numDoc && this.personToAddDocTypeSelected.id === this.policyOwner.docTypeSelected.id);
                if (!this.isAssuredTitular) {
                    this.personToAdd.isEqualToPersonToCover = (this.personToAddNumDoc === this.personToCover.numDoc && this.personToAddDocTypeSelected.id === this.personToCover.docTypeSelected.id);
                }
                // Verificar si ya existe un elemento con el mismo docType.id y docNum
                this.personToAdd.alreadyExists = this.familyMembers.some(member =>
                    member.docType.id === this.personToAddDocTypeSelected.id &&
                    member.docNum === this.personToAddNumDoc
                );
                //Si se ingresó dni de la persona a agregar se buscan los datos de la misma
                if (this.personToAddNumDoc != "" && this.personToAddNumDoc != null &&
                    !this.personToAdd.isEqualToPolicyOwner && !this.personToAdd.isEqualToPersonToCover && !this.personToAdd.alreadyExists) {
                    let dni = this.personToAddNumDoc;
                    let docTypeSeleccionado = this.personToAddDocTypeSelected.name.trim();
                    searchPersonService.GetSearchPersonData(dni, this.personToAddDocTypeSelected.id, false)
                        .then(response => {
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }
                            let result = response.searchPersonResult[0];
                            if (result != undefined && (result && result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.setPersonToAdd(result);
                            }
                            else {
                                this.personToAdd.isPersonExist = false;
                                this.personToAdd.activeFormPersonNotExist = true;
                                this.personToAdd.firstName = "";
                                this.personToAdd.email = "";
                                this.personToAdd.areaCode = "";
                                this.personToAdd.telephone = null;
                                this.personToAdd.age = "";
                                this.personToAdd.birthday = null;
                                this.personToAdd.selectedIvaCondition = (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"));
                                this.personToAdd.birthday = null;
                                this.personToAdd.lastName = "";
                                this.personToAdd.selectedLocality = null;
                            }
                            if (dni.toString().length > 0 && dni.toString().length < 9) {
                                this.personToAdd.MaximDigitSuperatedDni = false;
                            }
                            else {
                                if (docTypeSeleccionado == "DNI") {
                                    this.personToAdd.MaximDigitSuperatedDni = true;
                                    this.personToAdd.firstName = "";
                                    this.personToAdd.lastName = "";
                                    this.personToAdd.birthday = null;
                                    this.personToAdd.isPersonExist = false;
                                    this.personToAdd.isNotSelectedDocumentType = false
                                    this.personToAdd.age = "";
                                    this.personToAdd.activeFormPersonNotExist = true;
                                }
                                else {
                                    this.personToAdd.MaximDigitSuperatedDni = true;
                                }
                            }
                        })
                        .catch(() => {
                        })
                        .then(() => {
                            NF.UI.Page.unblock();
                        })
                        .finally(() => {
                            if ((!this.isPeopleWithSameIdentifierModalOpen) && this.personToAdd != null && this.personToAdd.isPersonExist && this.personToAdd.isBirthdayCorrect) {
                                this.finallySetPersonToAddOrEdit();
                            };
                        });
                } else {
                    this.personToAddNumDoc = null;
                    NF.UI.Page.unblock();
                }
            },
            finallySetPersonToAddOrEdit() {
                if (this.personToAdd != null && this.personToAdd.isPersonExist && this.personToAdd.isBirthdayCorrect) {
                    this.addOrEditPerson(this.personToEditId);
                }
            },
            addOrEditPerson(personToEditId = 0) {
                if (personToEditId !== 0) {
                    this.familyMembers[personToEditId - 1] = {
                        id: personToEditId,
                        isPersonExist: this.personToAdd.isPersonExist,
                        birthday: this.personToAdd.birthday,
                        firstName: this.personToAdd.firstName,
                        lastName: this.personToAdd.lastName,
                        docNum: this.personToAdd.docNum,
                        docType: this.personToAdd.docType,
                        email: this.personToAdd.email,
                        selectedIvaCondition: this.personToAdd.selectedIvaCondition,
                        areaCode: this.personToAdd.areaCode,
                        telephone: this.personToAdd.telephone,
                        hasLocality: this.personToAdd.hasLocality,
                        MaximDigitSuperatedDni: this.personToAdd.MaximDigitSuperatedDni,
                        age: this.personToAdd.age,
                        selectedLocality: this.personToAdd.selectedLocality,
                        address: this.personToAdd.address,
                        kinship: this.addChild ? this.kinshipRelations.find(relation => relation.id === 1) : this.kinshipRelations.find(relation => relation.id === 3),
                        relation: this.addChild ? this.quotationPersonsRelationList.find(relation => parseInt(relation.id) === 1) : this.quotationPersonsRelationList.find(relation => parseInt(relation.id) === 3),
                    };
                } else {
                    this.familyMembers.push({
                        id: this.familyMembers.length + 1,
                        isPersonExist: this.personToAdd.isPersonExist,
                        birthday: this.personToAdd.birthday,
                        firstName: this.personToAdd.firstName,
                        lastName: this.personToAdd.lastName,
                        docNum: this.personToAdd.docNum,
                        docType: this.personToAdd.docType,
                        email: this.personToAdd.email,
                        selectedIvaCondition: this.personToAdd.selectedIvaCondition,
                        areaCode: this.personToAdd.areaCode,
                        telephone: this.personToAdd.telephone,
                        hasLocality: this.personToAdd.hasLocality,
                        MaximDigitSuperatedDni: this.personToAdd.MaximDigitSuperatedDni,
                        age: this.personToAdd.age,
                        selectedLocality: this.personToAdd.selectedLocality,
                        address: this.personToAdd.address,
                        kinship: this.addChild ? this.kinshipRelations.find(relation => relation.id === 1) : this.kinshipRelations.find(relation => relation.id === 3),
                        relation: this.addChild ? this.quotationPersonsRelationList.find(relation => parseInt(relation.id) === 1) : this.quotationPersonsRelationList.find(relation => parseInt(relation.id) === 3),
                    });
                }
                this.personToAddNumDoc = null;
                this.closePersonToAddModal();
            },
            ageCalculate() {
                this.messageErrorAge = "";
                let birthDate = null;
                let age = null;
                let m = null;
                if (this.personToAdd.birthday != null && this.personToAdd.birthday != "") {
                    let today = new Date();
                    if (this.personToAdd.birthday.toString().length > 11) {
                        birthDate = new Date(this.personToAdd.birthday);
                        age = today.getFullYear() - birthDate.getFullYear();
                        m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                        }
                        this.personToAdd.age = age;
                    }
                    else {
                        let dateFormated = this.personToAdd.birthday.split('/')[1] + "/" + this.personToAdd.birthday.split('/')[0] + "/" + this.personToAdd.birthday.split('/')[2];
                        birthDate = new Date(dateFormated);
                        age = today.getFullYear() - birthDate.getFullYear();
                        m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                        }
                        this.personToAdd.age = age;
                    }
                    if (this.addChild) {
                        if (age > 24) {
                            this.messageErrorAge = "La persona debe ser menor de 24 años"
                        }
                    } else {
                        if (age < 18) {
                            this.messageErrorAge = "La persona debe ser mayor de 18 años"
                        }
                        if (age > 64) {
                            this.messageErrorAge = "La persona debe tener menos de 65 años";
                        }
                    }
                    if (this.messageErrorAge == "") {
                        this.personToAdd.isBirthdayCorrect = true;
                    } else {
                        this.personToAdd.isBirthdayCorrect = false;
                    }
                    this.personToAdd.age = age;
                }
                else {
                    this.personToAdd.age = 0;
                }
            },
            payButtonDisableValidation: function () {
                if (this.familyToCover === this.familyMembers.length
                ) {
                    this.payButtonDisable = false;
                } else {
                    this.payButtonDisable = true;
                }
            },
        },
        watch: {
            'personToAdd.birthday': function (newVal, oldVal) {
                if (newVal !== null && newVal !== "") {
                    this.ageCalculate();
                }
            },
            familyMembers(newVal, oldVal) {
                if (newVal.length === this.familyToCover) {
                    this.addSpouseDisable = this.addChildDisable = true;
                    this.addSpouseDisableTooltipText = `Solo se puede${this.familyToCover > 1 ? 'n' : ''} agregar ${this.familyToCover} familiar${this.familyToCover > 1 ? 'es' : ''}`;
                    this.addChildDisableTooltipText = `Solo se puede${this.familyToCover > 1 ? 'n' : ''} agregar ${this.familyToCover} familiar${this.familyToCover > 1 ? 'es' : ''}`;
                } else {
                    this.addSpouseDisable = this.addChildDisable = false;
                    this.addSpouseDisableTooltipText = this.addChildDisableTooltipText = "";
                    const isSpouseExists = newVal.some(member => member.kinship.id === 3);
                    if (isSpouseExists) {
                        this.addSpouseDisable = true;
                        this.addSpouseDisableTooltipText = "Solo se puede agregar un Cónyuge";
                    } else {
                        this.addSpouseDisable = false;
                        this.addSpouseDisableTooltipText = "";
                    }
                }
                if (newVal.length > this.familyToCover) { this.familyMembers = oldVal; }
                this.payButtonDisableValidation();
            }
        },
        mounted() {
            NF.UI.Page.block();
            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            this.thereIsDiscount = sessionStorage.getItem("thereIsDiscount") === 'true';
            this.getDocumentType();
            this.getIvaConditions();
            this.getQuotationPersonsRelation();
            this.changeTitleAndIcon();
            let gridCovers = JSON.parse(sessionStorage.getItem("responseGetVWHealthGridCovers"));
            // Extraer listado de beneficios adicionales
            let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"));
            let groupId = peopleToCover === 1 ? 1 : 3;
            this.additionalCover = gridCovers.vwGridCovers.filter(item => item.gridCategoriesId === 2 && item.verticalGroupsId.includes(groupId)).map(item => {
                return {
                    coverDescription: item.coverDescription.trim()
                };
            });
            this.familyToCover = peopleToCover - 1;
            let planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
            this.currentGroup = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);
            let coversCapitalAndDescription = JSON.parse(sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (this.currentGroup)));
            this.coversDetail = coversCapitalAndDescription;
            let planData = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
            const formatDate = (dateString: string): string => {
                const date = new Date(dateString);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear().toString();
                return `${day}/${month}/${year}`;
            };

            // Asignar las fechas formateadas
            this.effectDate = formatDate(planData.effectDate);
            this.expirationDate = formatDate(planData.expirationDate);
            let group = JSON.parse(sessionStorage.getItem("groupSelected"));
            this.planName = group.name;

            if (planDataSelected != null) {
                this.DataPlan = planDataSelected!;
                this.primerCuota = this.DataPlan.premioMensual;
                this.premiumWithoutDiscount = this.thereIsDiscount ? this.DataPlan.premiumWithoutDiscount : null;
                this.capital = this.DataPlan.capital;
            }
            this.isAssuredTitular = sessionStorage.getItem("isAssuredTitular") === 'true';
            if (!this.isAssuredTitular) {
                this.personToCover = JSON.parse(sessionStorage.getItem("personToCover"));
            };
            this.policyOwner = JSON.parse(sessionStorage.getItem("policyOwner"));
            this.currentStep = this.isAssuredTitular ? 2 : 3;
            this.totalStep = sessionStorage.getItem("totalStep");
            NF.UI.Page.unblock();
        }
    })
